import { render, staticRenderFns } from "./Jobs2.vue?vue&type=template&id=5fd688bc"
import script from "./Jobs2.vue?vue&type=script&lang=ts"
export * from "./Jobs2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports